import React from 'react';
import {useTranslation} from "react-i18next";
import BlockButton from "../components/block-button";
import UnderlineButton from "../components/underline-button";
import {useNavigate} from "react-router-dom";
import {createSwapOrder} from "../services/pairing-service";
import {CreateWatchOrderResponse, planState} from "../states/plan-state/plan-atoms";
import {useSetRecoilState} from "recoil";

const ReplaceWarning = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const setPlanState = useSetRecoilState(planState);
  const getDeviceName = () => {
    return  JSON.parse(localStorage.getItem('watchInfo'))?.displayName;
  }
  const navigateBackPage = () => {
    navigate("/activate-smartwatch");
  };

  const navigateEmergencyAddress = () => {
    navigate("/emergency-address");
  };

  const navigateRegisterAddress = () => {
    navigate("/register-address");
  };

  const callCreateSwapOrder = () => {
    createSwapOrder({
      tmoBillingAccountId: Number(localStorage.getItem('selectedTmoBillingAccountId')) || 0,
      pairAccountId: Number(localStorage.getItem('selectedPairAccountId')) || 0,
    }).then((response: CreateWatchOrderResponse) => {
      setPlanState((prevState) => ({
        ...prevState,
        customerOrderId: response?.customerOrderId,
        createWatchOrderResponse: response,
      }));
      response?.capturedAddress?.parameters.find(
        (x) => x.shortCode === "addressType",
      )?.value === "existing"
        ? navigateEmergencyAddress()
        : navigateRegisterAddress();
    });
  }

  return (
    <div className="layout-default">
      <h2 className="layout-default-left watch-title">
        {t("replaceButton") + " " + getDeviceName()}
      </h2>
      <p className="layout-default-left">{t("replaceSubText")}</p>
      <BlockButton
        onClick={callCreateSwapOrder}
        dataTestId="done-button"
        text={t("replaceButton")}
      />
      <UnderlineButton click={navigateBackPage} dataTestId="cancelButton" text={t("cancelText")} />
    </div>
  );
};

export default ReplaceWarning;